import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import './FilledCircularProgress.scss';

const FilledCircularProgress = ({ size, percentage, variant, children }) => {
  const radius = size / 2;
  const innerRadius = radius * 0.85; // Slightly smaller to create a border effect

  // Calculate the path for the filled arc
  const createPath = (percent) => {
    if (percent === 0) return '';
    if (percent === 100) return `M ${radius} ${radius} m 0 -${innerRadius} a ${innerRadius} ${innerRadius} 0 1 1 0 ${2 * innerRadius} a ${innerRadius} ${innerRadius} 0 1 1 0 -${2 * innerRadius} Z`;

    const angle = (percent / 100) * 2 * Math.PI;
    const x = radius + innerRadius * Math.sin(angle);
    const y = radius - innerRadius * Math.cos(angle);
    const largeArcFlag = percent > 50 ? 1 : 0;

    return `M ${radius} ${radius} L ${radius} ${radius - innerRadius} A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 1 ${x} ${y} Z`;
  };

  return (
    <div className={clsx('filled-circular-progress', `filled-circular-progress--${variant}`)} style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        {/* Background circle */}
        <circle className="filled-circular-progress__track" cx={radius} cy={radius} r={innerRadius} />
        {/* Progress fill */}
        {percentage > 0 && <path className="filled-circular-progress__fill" d={createPath(percentage)} />}
      </svg>
      {/* Content overlay */}
      {children && <div className="filled-circular-progress__content">{children}</div>}
    </div>
  );
};

FilledCircularProgress.propTypes = {
  size: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired,
  variant: PropTypes.oneOf(['default']),
  children: PropTypes.node,
};

FilledCircularProgress.defaultProps = {
  variant: 'default',
  children: null,
};

export default FilledCircularProgress;
